import fetch from 'node-fetch'
import {
  setCustomerToken,
  throwUserErrors
} from '../utils'

export default function useLogin() {
  return async function(email: string = '', password: string = '') {
    const apiUrl = process.env.NEXT_PUBLIC_PROTOCOL+''+process.env.NEXT_PUBLIC_STORE_DOMAIN + '/api/auth/login'
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          password
        })
      });

      return new Promise((resolve, reject) => {
        response.json()
        .then(body => {
          resolve(body?.token);
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
      });
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
